import { HomeActionTypes } from './home.types';

export const initialState = {
  loading: false,
  homeContent: [],
  showLoadingError: false,
  sawHome: false,
  aiChatWrapRef: null,
  menuIsOpen: true,
};

const homeReducer = (state = initialState, action) => {
  switch (action.type) {
    case HomeActionTypes.SET_AI_WRAPPER_REF: {
      return {
        ...state,
        aiChatWrapRef: action.payload.aiWrapperRef,
      };
    }
    case HomeActionTypes.HOME_SET: {
      return {
        ...state,
        homeContent: action.payload,
      };
    }
    case HomeActionTypes.HOME_LOADING: {
      return {
        ...state,
        loading: action.payload,
      };
    }
    case HomeActionTypes.HOME_GET_FAILURE: {
      return {
        ...state,
        showLoadingError: true,
      };
    }
    case HomeActionTypes.HOME_GET_REQUEST: {
      return {
        ...state,
        showLoadingError: false,
      };
    }
    case HomeActionTypes.HOME_RESET_STATE: {
      return {
        ...initialState,
      };
    }
    case HomeActionTypes.SAW_HOME: {
      return {
        ...state,
        sawHome: true,
      };
    }
    case HomeActionTypes.MENU_IS_OPEN: {
      return {
        ...state,
        menuIsOpen: action.payload,
      };
    }
    default:
      return state;
  }
};

export default homeReducer;
